
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 367.26 244.26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M172.02 0a111.85 111.85 0 01103.63 69.77c1.43-.07 2.87-.1 4.31-.1a87.3 87.3 0 110 174.59h-38.44v-.36H125.74v.36H72.68A72.68 72.68 0 0160.84 99.9 111.83 111.83 0 01172.02 0zm-29.25 221.9h81.72v-69.06h40.85l-81.71-99.46-81.71 99.52h40.85v69z","fill-rule":"evenodd"}})])
          )
        }
      }
    